import { render, staticRenderFns } from "./GlobalEditor.vue?vue&type=template&id=6a7855aa&scoped=true"
import script from "./GlobalEditor.vue?vue&type=script&lang=js"
export * from "./GlobalEditor.vue?vue&type=script&lang=js"
import style0 from "./GlobalEditor.vue?vue&type=style&index=0&id=6a7855aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7855aa",
  null
  
)

export default component.exports